import CustomersReferenceInput from './CustomersReferenceInput'

export default CustomersReferenceInput
